import { IonFabButton, IonIcon, useIonAlert } from '@ionic/react';
import { trashOutline } from 'ionicons/icons';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { UseMutationResult } from 'react-query';
import { useNavigate } from 'react-router';
import { TEST_IDS } from '../../config/utils/constants';
import { GenericResponse } from '../../interfaces/shared.interface';
import { selectIsCompanyOwner } from '../../store/companies/companiesSlice';
import { setToast } from '../../store/core/coreSlice';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { Loading } from './Loading';

interface Props {
  submitData: Record<string, string | number | undefined>;
  deleteHook: () => UseMutationResult<GenericResponse, Error, void, unknown>;
}

export const DeleteIconButton = ({ submitData, deleteHook }: Props) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const [presentAlert] = useIonAlert();
  const { mutate: deleteEntity, isLoading, isSuccess, data: resp } = deleteHook();
  const isCompanyOwner = useAppSelector(selectIsCompanyOwner);

  useEffect(() => {
    if (isSuccess) {
      if (resp?.success) {
        navigate(-1);
      }

      dispatch(
        setToast({
          value: {
            show: true,
            msg: resp?.error || resp?.errorCode || t('SHARED.DELETE_SUCCESSFUL'),
            isError: !resp?.success || false,
          },
        }),
      );
    }
  }, [dispatch, isSuccess, navigate, resp?.error, resp?.errorCode, resp?.success, t]);

  const showConfirmationDialog = () => {
    presentAlert({
      mode: 'ios',
      header: t('FORMS.CONFIRM_DELETE_MSG'),
      buttons: [
        {
          text: t('SHARED.CANCEL'),
          role: 'cancel',
          cssClass: 'noTextTransformation',
        },
        {
          text: t('SHARED.CONFIRM'),
          role: 'confirm',
          handler: () => {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            deleteEntity(submitData);
          },
          cssClass: 'noTextTransformation',
        },
      ],
    });
  };

  const onClick = () => {
    console.log('onClick');
    showConfirmationDialog();
  };

  if (!isCompanyOwner) return null;

  return (
    <>
      <div className="deleteIcon flex-center-center-row-wrap" onClick={(e) => e.stopPropagation()}>
        <IonFabButton size="small" color="light" onClick={onClick} id={TEST_IDS.Shared.deleteIconButton}>
          <IonIcon icon={trashOutline} color="danger"></IonIcon>
        </IonFabButton>
      </div>
      {isLoading && <Loading />}
    </>
  );
};
